(function () {
  function ensurePageClass() {
    var marker = document.querySelector('[data-lv-page-type]');
    if (marker && marker.dataset.lvPageType) {
      document.body.classList.add('template-' + marker.dataset.lvPageType);
    }
  }

  function enhanceCollectionCards(root) {
    if (!document.body.classList.contains('template-collection')) return;
    (root || document).querySelectorAll('.product-card-wrapper:not([data-lv-card-ready])').forEach(function (card) {
      var titleLink = card.querySelector('.card__heading a[href]');
      var content = card.querySelector('.card > .card__content');
      if (!titleLink || !content) return;

      var cta = document.createElement('a');
      cta.className = 'lv-card-cta';
      cta.href = titleLink.href;
      cta.textContent = 'Pedir — paga al recibir';

      var note = document.createElement('p');
      note.className = 'lv-card-cta__note';
      note.textContent = 'Sin pago por adelantado';

      content.appendChild(cta);
      content.appendChild(note);
      card.setAttribute('data-lv-card-ready', 'true');
    });
  }

  function enhanceProductButton(root) {
    if (!document.body.classList.contains('template-product')) return;
    (root || document).querySelectorAll('.main-product-atc span:not(.sold-out-message)').forEach(function (label) {
      if (label.textContent.trim()) label.textContent = 'Pedir — paga al recibir';
    });
  }

  function enhanceHome() {
    if (!document.body.classList.contains('template-index')) return;
    var shell = document.querySelector('[data-lv-home-injected]');
    var main = document.getElementById('MainContent');
    if (!shell || !main || shell.getAttribute('data-lv-mounted') === 'true') return;
    Array.prototype.forEach.call(main.children, function (child) {
      child.hidden = true;
      child.setAttribute('data-lv-original-home', 'true');
    });
    shell.hidden = false;
    shell.setAttribute('data-lv-mounted', 'true');
    main.insertBefore(shell, main.firstChild);
  }

  function enhance(root) {
    ensurePageClass();
    enhanceCollectionCards(root);
    enhanceProductButton(root);
    enhanceHome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  } else {
    enhance(document);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) enhance(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
